import { BaseRestRepository } from '~/repositories/baseRestRepository';
import { leasingServiceUrl, settingsServiceUrl } from '~/utils/env';

const SETTINGS_BASE_URL = `${settingsServiceUrl()}/company-portal/settings`;
const RENTAL_APPLICATION_BILLING_SETTINGS_URL = `${SETTINGS_BASE_URL}/rentalapplicationbilling`;
const RENTAL_APPLICATION_BILLING_COMPANY_SETTINGS_URL = `${RENTAL_APPLICATION_BILLING_SETTINGS_URL}/company`;
const PAYMENT_SUMMARY_URL = `${leasingServiceUrl()}/company-portal/rental-applications/breakdown`;

export class RentalApplicationBillingSettingsRepository extends BaseRestRepository {
  public async getRentalApplicationBillingSettings(): Promise<any> {
    const response = await this.fetchWithAuth(RENTAL_APPLICATION_BILLING_COMPANY_SETTINGS_URL);
    return this.getJsonResponse(response);
  }

  public async deleteRentalApplicationBillingSettings(): Promise<void> {
    return undefined;
  }

  public async updateRentalApplicationBillingSettings(payload: any): Promise<any> {
    const response = await this.fetchWithAuth(RENTAL_APPLICATION_BILLING_COMPANY_SETTINGS_URL, {
      method: 'POST',
      body: JSON.stringify({ settings: payload }),
    });
    return this.getJsonResponse(response);
  }

  public async getRentalApplicationPaymentSummary(): Promise<any> {
    const response = await this.fetchWithAuth(PAYMENT_SUMMARY_URL);
    return this.getJsonResponse(response);
  }
}
